import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { Caption01 } from 'components/styles';

export const Divider = styled.hr`
  margin: var(--layout-01);
  border: none;
  border-top: 1px solid var(--border-color);
`;

export const Label = styled.div`
  ${Caption01};
  padding: 0 var(--layout-01);
  margin: 0 0 var(--spacing-03);
  color: var(--gray-50);
`;

export const Action = styled(Button).attrs({
  type: 'text',
})`
  --action-hover-background: var(--item-hover-bg);

  &:hover,
  &:focus,
  &:active {
    background: var(--action-hover-background);
  }
`;
